import TYPES               from "@/core/services/Changelogs/types";

import Title_ru_RU         from "@/core/misc/decorators/Title_ru_RU";
import Title_ru_RU_Class   from "@/core/misc/decorators/Title_ru_RU_Class";
import serializeSimplified from "@/core/misc/decorators/SerializeSimplified";

import BaseEntity          from "@/core/misc/BaseEntity";
import Core                from "@/core/Core";
import Person              from "@/domains/Persons/Person";

// type-only: Driver сам импортирует DriverFeedback, рантайм-цикл не нужен
import type Driver from "@/domains/Drivers/Driver";

@Title_ru_RU_Class('Оценка водителя')               // driverFeedback → DriverFeedback
class DriverFeedback extends BaseEntity {
  static Events = {
    Created: 'driverFeedback:created',
    Updated: 'driverFeedback:updated',
  } as const;

  /**
   * Водитель. Обратную ссылку ставит Driver.fromServer либо фабрика fromDriver;
   * в списке оценок (driverFeedbacks.getList) не заполняется — водитель там известен вызывающему
   */
  @Title_ru_RU('Водитель', TYPES.OBJECT)
  @serializeSimplified
  public driver: Driver;

  /** Автор оценки. На бэке всегда подменяется текущим пользователем */
  @Title_ru_RU('Автор', TYPES.OBJECT)
  @serializeSimplified
  public owner: Person;

  /** Оценка 1-5 */
  @Title_ru_RU('Оценка', TYPES.NUMBER)
  public rate: number;

  @Title_ru_RU('Комментарий', TYPES.STRING)
  public comment: string | null;

  /** Новая оценка водителя от текущего пользователя */
  static fromDriver(driver: Driver): DriverFeedback {
    const feedback = new this();

    feedback.driver = driver;
    feedback.owner  = Core.currentUser;

    return feedback;
  }

  static fromServer(data: any, feedback = new DriverFeedback()): DriverFeedback {
    super.fromServer(data, feedback);

    feedback.owner = Core.utils.hydrate(data.owner, Person.fromServer)!;

    return feedback;
  }

  /** Почему оценку поставить нельзя; null — можно */
  getReasonCannotRate(): string | null {
    if (Core.utils.isNullOrUndefined(this.driver) === true) {
      return 'Чтобы оценить водителя, выберите его';
    }
    else if (this.driver.isExisting === false) {
      return 'Оценить водителя можно после его сохранения';
    }
    else {
      return null;
    }
  }

  /** Почему отзыв написать нельзя; null — можно. Отзыв без оценки бэк не примет */
  getReasonCannotComment(): string | null {
    const reasonCannotRate = this.getReasonCannotRate();

    if (reasonCannotRate !== null) {
      return reasonCannotRate;
    }
    else if (Core.utils.isNullOrUndefined(this.rate) === true) {
      return 'Чтобы написать отзыв, поставьте оценку';
    }
    else {
      return null;
    }
  }
}

export default DriverFeedback;
